import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import Button from '@mui/material/Button';

import logoNoType from 'auth/assets/bsl-logo.png';

import {
  PageWrapper,
  ContentWrapper,
  Logo,
  Paragraph,
} from './RestrictedPage.style';

const RestrictedPage = ({ customError = 'Page Not Found' }) => (
  <PageWrapper>
    <ContentWrapper>
      <Logo src={logoNoType} alt="Blue Sky Link Logo" />
      <Paragraph>{customError}</Paragraph>
      <Paragraph>You do not have access to this page.</Paragraph>
      <Paragraph>
        If you think you have seen this message in error, please contact a Blue
        Sky administrator.
      </Paragraph>
      <Paragraph>
        <Button component={Link} to="/" color="primary" variant="contained">
          GO TO Homepage
        </Button>
      </Paragraph>
    </ContentWrapper>
  </PageWrapper>
);

RestrictedPage.propTypes = {
  customError: PropTypes.string,
};

export default RestrictedPage;
